// import { Button } from '@drip/drip-design';
import React, { useState, useEffect } from 'react';
import TimeControl from './components/time-control';
import FilterTag from '@/components/filter-tag';
import './index.less';
import FormCriteria from './components/form-criteria';
import TargetSelect from './components/target-select';
import DownLoadModal from './components/download-modal';
import AnalysisTableV2 from './components/tableV2';
import classnames from 'classnames';
import { filterConditions } from '@/common/utils';
// @ts-ignore
import { Label, Button, Tag } from '@jd/jmtd';

interface conditionsType {
  userType: string;
  buId?: string;
  deptId1?: string;
  deptId2?: string;
  deptId3?: string;
  deptId4?: string;
  participant: string;
  dataType: string;
  total?: number;
  itemType: string;
  scope: string;
  indicators?: any[] | [] | null;
  pageSize: number;
  pageNo: number;
  criteria: {
    sku_id?: string;
    spu_id?: string;
    shop?: string[];
    cate_1?: string[];
    cate_2?: string[];
    cate_3?: string[];
    cate_4?: string[];
    main_brand?: string[];
    platform_cate_1?: string;
    first_place_cd?: string;
    second_place_cd?: string;
    third_place_cd?: string;
  };
  orders: {
    propertyName: string;
    ascending?: boolean;
  };
  modelId: string;
  download: boolean;
  timeType?: string;
  channelType?: string;
  token?: string;
}

function SkuAnalysis(props: any) {
  const { filter, dataScopeFilter, originFilter, onChangeOriginFilter, curLog } = props;
  console.log({curLog})
  const [conditions, setConditions] = useState<conditionsType>({
    userType: '',
    participant: '',
    dataType: 'REALTIME',
    itemType: '1',
    scope: '1',
    indicators: null,
    pageSize: 10,
    pageNo: 1,
    criteria: {},
    orders: {
      propertyName: 'ge_deal_standard_deal_ord_amt',
      ascending: false,
    },
    modelId: '',
    download: false,
  });

  const [modalVisible, setModalVisible] = useState(false);

  const [selPlaceList, setSelPlaceList] = useState([])
  const [placeList, setPlaceList] = useState([])
  const [planList, setPlanList] = useState([])

  useEffect(() => {
    setConditions((data: any) => Object.assign({}, data, filter, { criteria: {} }));
  }, [filter]);

  const changeConditions = (query: any) => {

    setConditions((data: any) => Object.assign({}, data, query));
  };
  const changeItemType = (val: string) => {
    const { criteria } = conditions;
    changeConditions({ itemType: val, criteria: filterConditions({ ...criteria, sku_id: '', spu_id: '' }) });
  };

  function handleCustomLog(p:any){
    props.handleCustomLog(p)
  }
  return (
    <div className="participant-data-sku-analysis">
      <div className="sku-analysis-header">
        <div className="sku-analysis-header-title">数据明细
          {
            props?.selObj?.skuNum!= null && <span className="sku-analysis-header-sub-title">共计{props?.selObj?.skuNum}个商品</span>
          }
        </div>
        <Button semantic='primary' onClick={() => setModalVisible(true)} clsTag={'h|keycount|yx_center_hzcp_1678258944439|16'}>
          导出数据
        </Button>
      </div>
      <div className="sku-analysis-tab-time-block">
        <div className="sku-analysis-tab-radio">
          <Button link className={classnames('radio-tab-item', { 'radio-tab-item-checked': conditions.itemType === '1' })}
                  onClick={() => changeItemType('1')}>SKU
          </Button>
          <Button link className={classnames('radio-tab-item', {'radio-tab-item-checked': conditions.itemType === '2'})}
                  clsTag={'h|keycount|yx_center_hzcp_1678258944439|13'} onClick={() => changeItemType('2')}>SPU
          </Button>
        </div>
        {/* 离线、实时 时间选择*/}
        <TimeControl onChange={(val: any) => changeConditions({ ...val })} handleLog={props.handleLog} handleCustomLog={props.handleCustomLog}/>
      </div>
      <FormCriteria
        dataScopeFilter={dataScopeFilter}
        itemType={conditions.itemType}
        filter={filter}
        originFilter={originFilter}
        onChange={(val: any) => changeConditions({ criteria: val })}
        onChangeOriginFilter={onChangeOriginFilter}
        setPlaceList={setPlaceList}
        setPlanList={setPlanList}
        setSelPlaceList={setSelPlaceList}
      />
      <div className="select-range">
        <span>商品展示范围</span>
        <FilterTag.Group
          border={false}
          value={conditions.scope}
          onChange={(val: any) => changeConditions({ scope: val })}
        >
          <FilterTag value="1" key={1}>
            全部
          </FilterTag>
          <FilterTag value="2" key={2}>
            仅我关注
          </FilterTag>
        </FilterTag.Group>
      </div>
      <TargetSelect
        dataType={conditions.dataType}
        itemType={conditions.itemType}
        onChange={(val: any) => changeConditions({ indicators: val })}
      />
      <AnalysisTableV2 handleLog={props.handleLog} handleCustomLog={props.handleCustomLog} erp={props.erp} filter={filter} conditions={conditions} onChange={changeConditions} skuGroupId={props.skuGroupId} selObj={props.selObj} placeList={placeList} planList={planList} selPlaceList={selPlaceList} />
      <DownLoadModal visible={modalVisible} setVisible={setModalVisible} conditions={conditions} item={false} downloadBySku={false} skuGroupId={props.skuGroupId} selObj={props.selObj}/>
    </div>
  );
}

export default SkuAnalysis;
